import { INTEGRATION_METADATA } from '../constants/integration-metadata';
import { Integration } from '../types/integration';

export const apps: Integration[] = Object.values(INTEGRATION_METADATA).map((metadata) => ({
  name: metadata.name,
  desc: metadata.description,
  connected: false,
  isAvailableToPublic: metadata.isAvailableToPublic,
  logoUrl: metadata.logoUrl,
}));
